import { get } from 'lodash'
import { Paths } from 'type-fest'
import { sortByIgnoreCase } from './arrays'

interface ListInputItem<ListItem extends string | Record<string, unknown>> {
  value?: string | null
  label: string
  item?: ListItem
  renderedLabel?: React.ReactNode
  disabled?: boolean
}

export const buildListAsInputOptions = <ListItem extends string | Record<string, any>>(
  list: ListItem[],
  options?: {
    sortBy?: string | null | ((item: ListInputItem<ListItem>) => boolean)
    labelKeyPath?: Paths<ListItem>
    valueKeyPath?: Paths<ListItem>
    labelBuilder?(item: ListItem): React.ReactNode
    renderLabel?(item: ListItem): React.ReactNode
    disabled?(item: ListItem): boolean
    blank?: {
      label: string
      value?: string
    }
  },
): ListInputItem<ListItem>[] => {
  if (!options) options = {}
  const { blank, sortBy } = options
  if (blank && !blank.value) blank.value = ''

  const items: ListInputItem<ListItem>[] = list.map(listItem => {
    const sanitized: ListInputItem<ListItem> = {
      value:
        typeof listItem === 'string' ? listItem : get(listItem, options?.valueKeyPath || '_id'),
      label:
        typeof listItem === 'string'
          ? listItem
          : options?.labelBuilder
            ? options.labelBuilder(listItem)
            : get(listItem, options?.labelKeyPath || 'name'),
      item: listItem,
      renderedLabel: options?.renderLabel && options.renderLabel(listItem),
      disabled: options?.disabled ? options.disabled(listItem) : false,
    }
    return sanitized
  })
  const itemsToReturn: ListInputItem<ListItem>[] = [...(blank ? [blank] : []), ...items]
  if (sortBy === null) {
    return itemsToReturn
  }
  return sortByIgnoreCase(
    itemsToReturn,
    sortBy ? (sortBy as keyof ListInputItem<ListItem>) : 'label',
  )
}
